import api from './api';
import type { PharmacyFeatureAuditEntry } from './pharmacyFeatures';

/** PRX-124 — one role's row on System configuration -> Landing pages. */
export interface RoleLandingPageRow {
  role: string;
  /** null = not set. */
  landingPage: string | null;
  /** False when the stored route is one the role's permissions no longer open. */
  allowed: boolean;
  /** The routes this role may be given (server-decided from the role's permissions). */
  allowedPages: string[];
}

export interface RoleLandingPagesResponse {
  pharmacyId: string;
  roles: RoleLandingPageRow[];
  recentChanges: PharmacyFeatureAuditEntry[];
}

/** The signed-in user's answer at one pharmacy. */
export interface MyRoleLandingPage {
  role: string | null;
  landingPage: string | null;
  /** True only when a page is set and the user's role may open it. */
  allowed: boolean;
}

/** A route sets the role's page; null clears it. */
export interface UpdateRoleLandingPagesRequest {
  landingPages: Record<string, string | null>;
}

const url = (pharmacyId: string) => `/api/pharmacies/${pharmacyId}/role-landing-pages`;

const roleLandingPagesService = {
  async get(pharmacyId: string): Promise<RoleLandingPagesResponse> {
    const response = await api.get<RoleLandingPagesResponse>(url(pharmacyId));
    return response.data;
  },

  async update(pharmacyId: string, payload: UpdateRoleLandingPagesRequest): Promise<RoleLandingPagesResponse> {
    const response = await api.patch<RoleLandingPagesResponse>(url(pharmacyId), payload);
    return response.data;
  },

  async mine(pharmacyId: string): Promise<MyRoleLandingPage> {
    const response = await api.get<MyRoleLandingPage>(`${url(pharmacyId)}/mine`);
    return response.data;
  },
};

export default roleLandingPagesService;
